import { EditNoteOutlined, RouterOutlined } from '@mui/icons-material'
import { Box, Tab, Tabs } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import {
  AppJsonConfigType,
  RaspiPropertiesConfigType,
  ResourceJsonConfigType,
} from '@/features/controller/configuration/utils/controllerConfigTypes'
import { ControllerRouteInformation } from '@/features/controller/constants'

interface ControllerConfigurationTabsProps {
  controllerId: string
  activeTab: string
}

const commonProps = {
  component: Link,
  disableRipple: true,
  iconPosition: 'start',
  style: { minHeight: 0 },
} as const

export function ControllerTabs({ controllerId, activeTab }: Readonly<ControllerConfigurationTabsProps>) {
  const { t } = useTranslation()

  return (
    <Box sx={{ mt: 2, borderBottom: 1, borderColor: 'divider' }}>
      <Tabs aria-label="customer-tabs" value={activeTab}>
        <Tab
          {...commonProps}
          icon={<RouterOutlined />}
          label={t('controllers.tabs.details')}
          to={ControllerRouteInformation.CONTROLLER_DETAILS.navigationPath(controllerId)}
          value={ControllerRouteInformation.CONTROLLER_DETAILS.routePath}
        />
        <Tab
          {...commonProps}
          icon={<EditNoteOutlined />}
          label={RaspiPropertiesConfigType.shortName}
          to={ControllerRouteInformation.CONTROLLER_CONFIG_RASPI_PROPERTIES.navigationPath(controllerId)}
          value={ControllerRouteInformation.CONTROLLER_CONFIG_RASPI_PROPERTIES.routePath}
        />
        <Tab
          {...commonProps}
          icon={<EditNoteOutlined />}
          label={AppJsonConfigType.shortName}
          to={ControllerRouteInformation.CONTROLLER_CONFIG_APP_JSON.navigationPath(controllerId)}
          value={ControllerRouteInformation.CONTROLLER_CONFIG_APP_JSON.routePath}
        />
        <Tab
          {...commonProps}
          icon={<EditNoteOutlined />}
          label={ResourceJsonConfigType.shortName}
          to={ControllerRouteInformation.CONTROLLER_CONFIG_RESOURCE_JSON.navigationPath(controllerId)}
          value={ControllerRouteInformation.CONTROLLER_CONFIG_RESOURCE_JSON.routePath}
        />
      </Tabs>
    </Box>
  )
}
